
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    reciever: () => import("@/components/reciever/reciever.vue")
  },

  beforeDestroy() {
    this.$nuxt.$off("trigger-order-next-action");
  },
  computed: {
    ...mapGetters("restaurant", ["isRecieverSubscribed"]),
    ...mapState("restaurant", ["locationDetails"])
  }
};
